import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { BrandColors } from '../../constants';
import { TemplateSettings } from '../../store/interfaces';

export const BaseStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: (props: TemplateSettings) => ({
      backgroundColor: props.utilityBar.backgroundColor,
      color: props.utilityBar.textColor,
      boxShadow: `0px 3px 3px ${BrandColors.blackWithOpacity}`,
      height: '40px',
      padding: '0 24px',
      justifyContent: 'center',
      [theme.breakpoints.up('md')]: {
        padding: '0 80px',
        height: '50px',
      },
      [theme.breakpoints.up('xl')]: {
        padding: '0 113px',
      },
    }),
    mobile: {
      [theme.breakpoints.down('md')]: {
        position: 'relative',
      },
    },
    logo: {
      flexGrow: 1,
      '& > img': {
        maxWidth: '10rem',
        height: '24px',
        marginTop: '0.5em',
        [theme.breakpoints.up('lg')]: {
          maxWidth: '15rem',
          height: '32px',
        },
      },
    },
    content: {
      marginTop: '40px',
      minHeight: 'calc(100vh - 40px - 165px)',
      [theme.breakpoints.up('md')]: {
        marginTop: '50px',
        minHeight: 'calc(100vh - 50px - 165px)',
      },
      [theme.breakpoints.up('lg')]: {
        minHeight: 'calc(100vh - 50px - 97px)',
      },
    },
    dektopMenuItem: (props: TemplateSettings) => ({
      backgroundColor: props.utilityBar.backgroundColor,
      color: `${props.utilityBar.textColor} !important`,
      border: 'none',
      fontSize: '1rem',
      lineHeight: '22px',
    }),
    desktopMenuUserProfile: (props: TemplateSettings) => ({
      backgroundColor: `${props.utilityBar.backgroundColor} !important`,
      minWidth: '9rem',
      border: 'none',
    }),
    desktopMenuSettings: (props: TemplateSettings) => ({
      backgroundColor: props.utilityBar.backgroundColor,
      padding: '0.25rem 0 0.25rem',
      minWidth: '200px',
      '& .language-label': {
        color: props.utilityBar.textColor,
        fontSize: '1rem',
        padding: '0 0.5rem 0.25rem',
      },
      borderRadius: '0.3125rem',
    }),
    desktopAccessibilitySettings: (props: TemplateSettings) => ({
      backgroundColor: props.utilityBar.backgroundColor,
      padding: '1.5rem 0.75rem 0.75rem',
      minWidth: '300px',
      textAlign: 'center',
    }),
  }),
);
